export enum ContainerType
{
	FunLocal = "FunLocal",
	FunProductCard = "FunProductCard",
	HCHoverRecs = "HCHoverRecs",
	HCLocal = "HCLocal",
	HCProductCard = "HCProductCard",
	RecentlyViewedSide = "RecentlyViewedSide"
}